/**
 * Mirrors {@code com.mvs.backend.ui.logic.UiDataSourceEnum}. The backend enum is persisted
 * ORDINAL, so the member ORDER here is the contract: entity=0, report=1, object_browser=2, ql=3,
 * entityGroupBy=4, qlQuery=5. Append only, never reorder.
 *
 * `qlQuery` (QL-Widget-Builder, ordinal 5) marks a {@code ui.UiWidget} whose data comes from a
 * typed, policy-checked {@code QlQueryDto} stored in {@code UiWidgetDto.qlQueryJson} — as opposed
 * to the legacy `ql` (ordinal 3), which is a bare entity alias with a free-form `parameterJson`.
 */
export enum UiDataSourceEnum {

   entity,
   report,
   object_browser,
   ql,
   entityGroupBy,
   qlQuery,
}